export { default } from './AreaChart';
